export default {"src":"/_next/static/media/sar.f03e266e.svg","height":13,"width":12};